import { Orders } from './api/';
import { handleError } from '@utils/misc';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CreditsT {}

export interface ResponseT {
  errors: Array<string>;
  data: Array<any>;
}

const useCreditsInfo = () => {

  const getCreditsInfo = async (token): Promise<ResponseT> => {
    let resp;

    try {
      resp = await Orders.credits(token);
    } catch (err) {
      handleError(err);
      return null;
    }

    // if (resp.data.errors.length > 0) {
    //   console.log('getUser ERRORS', resp.data.errors);
    // }
    return resp;
  };

  return {
    getCreditsInfo,
  };
};
export default useCreditsInfo;
